import React, { useEffect, useState } from 'react';

import { PanelsEnum } from '@ariksa/inventory-core/api';
import { useDisclosure } from '@chakra-ui/react';
import { isEmpty, map, orderBy, sumBy } from 'lodash';
import { useSelector } from 'react-redux';

import { formatNumberWithComma, getIconColor } from 'components/DataDisplay';
import formatNumber from 'components/DataDisplay/Utils/formatNumber';
import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import { useResourceType } from 'containers/App/hooks/useResourceType';
import { selectCloudPostureOverview } from 'containers/Dashboard/CloudPostureOverview/selectors';
import { AllEntitiesDrawer } from 'containers/Dashboard/Drawers/AllEntitiesDrawer';
import { AllEntitiesDetailsProps } from 'containers/Dashboard/types';
import { renderNoEntitiesFoundWithIcon } from 'containers/Dashboard/utils';
import { renderResourcesWithIconAndCount } from 'containers/Dashboard/utils/utils';
import { customTheme } from '../../../../../theme';

export const HighlyPrivilegedMachineIdentities: React.FC = () => {
  const { highlyExploitableMachines } = useSelector(selectCloudPostureOverview);
  const allEntitiesDisclosure = useDisclosure();
  const [details, setDetails] = useState<AllEntitiesDetailsProps>(
    {} as AllEntitiesDetailsProps,
  );
  const { getCloudAgnosticName } = useResourceType();
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setTotal(sumBy(highlyExploitableMachines.data?.items, o => o.count ?? 0));
  }, [highlyExploitableMachines.data]);

  return (
    <>
      <DashboardWidget
        isLoading={highlyExploitableMachines.isLoading}
        label="Machine Identities with High Privileges"
        noData={isEmpty(highlyExploitableMachines.data?.items)}
        noDataMessage={renderNoEntitiesFoundWithIcon('No machine identities')}
        subHeader={
          formatNumberWithComma(total) +
          ' machine identit' +
          (total === 1 ? 'y' : 'ies')
        }
        content={renderResourcesWithIconAndCount(
          map(
            orderBy(
              highlyExploitableMachines.data?.items,
              ['resource_count'],
              ['desc'],
            ),
            o => ({
              label: getCloudAgnosticName(o.agnostic!),
              iconType: o.agnostic!,
              count: formatNumber(o?.count),
              iconColor: customTheme.colors.blue['300'],
              borderColor: getIconColor(o.agnostic!),
              onClick: () => {
                allEntitiesDisclosure.onOpen();
                setDetails({
                  panel: PanelsEnum.HighPrivilegesMachines,
                  iconType: o.agnostic!,
                  resourceType: o.agnostic,
                  resourceTypeClass: 'agnostic',
                  total: o?.count ?? 0,
                });
              },
            }),
          ),
        )}
        styles={{ contentWrapper: { px: 0, pb: 0 } }}
      />
      <AllEntitiesDrawer
        isOpen={allEntitiesDisclosure.isOpen}
        onClose={allEntitiesDisclosure.onClose}
        {...details}
      />
    </>
  );
};
